import React from "react";

import RadioCardSelect from "../RadioCardSelect";

import TopperLogo from "../../img/icons/topper.svg";
import SimplexLogo from "../../img/icons/simplex.svg";
import C14Logo from "../../img/icons/c14.svg";
import WarningIcon from "../../img/icons/warning.svg";
import { useState } from "react";

import * as styles from "./component.module.scss";
import TopperProvider from "./Providers/TopperProvider";
import SimplexProvider from "./Providers/SimplexProvider";
import C14Provider from "./Providers/C14Provider";

const BuySection = () => {
  const [selectedProvider, setSelectedProvider] = useState("c14");
  const [selectedStep, setSelectedStep] = useState("select");

  const selectedProviderElement =
    selectedProvider === "topper" ? (
      <TopperProvider />
    ) : selectedProvider === "simplex" ? (
      <SimplexProvider />
    ) : (
      <C14Provider />
    );

  return (
    <div className={styles.main}>
      <h2 className={styles.title}>Buy DAG</h2>
      {selectedStep !== "select" ? (
        selectedProviderElement
      ) : (
        <div className={styles.providerSelectionCard}>
          <div>
            <h3>Select a provider</h3>
            <span>
              Please choose from this list of Lattice-trusted providers to buy
              your tokens from.
            </span>
          </div>
          <div className={styles.providers}>
            <RadioCardSelect
              icon={<C14Logo />}
              label={"C14"}
              selected={selectedProvider === "c14"}
              onClick={() => setSelectedProvider("c14")}
            />
            <RadioCardSelect
              icon={<TopperLogo />}
              label={"Topper"}
              selected={selectedProvider === "topper"}
              onClick={() => setSelectedProvider("topper")}
            />
            <RadioCardSelect
              icon={<SimplexLogo />}
              label={"Simplex"}
              selected={selectedProvider === "simplex"}
              onClick={() => setSelectedProvider("simplex")}
            />
          </div>
          <button
            className={styles.button}
            onClick={() => setSelectedStep("provider-selected")}
          >
            Next
          </button>
        </div>
      )}
      <div className={styles.controlArrows}></div>
      <div className={styles.warningMessage}>
        <WarningIcon />
        <p>
          {selectedProvider === "topper"
            ? "Topper"
            : selectedProvider === "simplex"
            ? "Simplex"
            : "C14"}{" "}
          is provided as a third-party Service only, and does not constitute
          trading advice, financial advice, investment advice or any other sort
          of advice.{" "}
          <p>
            <span>
              Your access to and use of the Service is at your own risk.
            </span>{" "}
            Do conduct your own due diligence and consult your financial advisor
            before engaging in any transaction.
          </p>
        </p>
      </div>
    </div>
  );
};

export default BuySection;
